import {bindActionCreators} from 'redux'
import {connect} from '../../redux/utils'
import {getIsOpenTaskCompleted, getOpenTaskId, getOpenTaskNextId, isLoading, isNeedToLoadData, isPanelOpened} from '../../panels/task/editPanel/selectors'
import {closeEditTaskPanel, copyLinkTo, loadEditTaskPanelData, openEditTaskPanel} from '../../panels/task/editPanel/actions'
import EditTaskPanelContainer from '../../panels/task/editPanel/EditTaskPanelContainer'
import { getAccessRights } from '../../loggedInUser/selectors'
import { isTSTEnabled } from '../../features/selectors'

export default connect(
    state => ({
        isShown: isPanelOpened(state),
        needToLoadData: isNeedToLoadData(state),
        loading: isLoading(state),
        openTaskId: getOpenTaskId(state),
        openTaskNextId: getOpenTaskNextId(state),
        isOpenTaskCompleted: getIsOpenTaskCompleted(state),
        isTSTEnabled: isTSTEnabled(state),
        userRights: getAccessRights(state),
    }),
    dispatch => ({
        openPanel: bindActionCreators(openEditTaskPanel, dispatch),
        onPanelHide: bindActionCreators(closeEditTaskPanel, dispatch),
        loadPanelData: bindActionCreators(loadEditTaskPanelData, dispatch),
        copyLink: bindActionCreators(copyLinkTo, dispatch),
    })
)(EditTaskPanelContainer)


// WEBPACK FOOTER //
// ./web/js/taskManagement/components/EditTaskPanelContainer.js